<template>
  <span class="time-count-down">{{ showTime }}</span>
</template>

<script>
import { formatTime } from "@/utils/filters";
import { setInterval } from "timers";
export default {
  props: ["time"],
  data() {
    return {
      showTime: "loading...",
      Timer: 0,
    };
  },
  mounted() {
    this.caculateTime();
    if (this.Timer === 0)
      this.Timer = setInterval(() => {
        this.caculateTime();
      }, 1000);
  },
  methods: {
    caculateTime() {
      let Dt = new Date();
      let local = Dt.getTime();
      let dValue = parseInt(local / 1000 - this.time);
      let h = parseInt(dValue / 3600);
      dValue -= h * 3600;
      let m = parseInt(dValue / 60);
      dValue -= m * 60;
      let s = parseInt(dValue);
      if (parseInt(local / 1000 - this.time) >= 86400)
        this.showTime = formatTime(this.time);
      else if (parseInt(local / 1000 - this.time) >= 3600)
        this.showTime = `${h}小时${m}分${s}秒前`;
      else if (parseInt(local / 1000 - this.time) >= 60)
        this.showTime = `${m}分${s}秒前`;
      else this.showTime = `${s}秒前`;
    },
  },
  beforeUnmount() {
    //清除定时器
    clearTimeout(this.Timer);
  },
};
</script>